import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Products() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} id="products" className="py-16 sm:py-24 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        {/* 강한 일본어 섹션 헤더 */}
        <div id="personal" className={`text-center mb-16 sm:mb-24 transition-all duration-1000 pt-20 -mt-20 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-[40px] sm:text-[52px] lg:text-[60px] font-bold text-white mb-3 sm:mb-5 tracking-tight px-4">
            LEXO <span className="bg-gradient-to-r from-red-500 via-red-400 to-orange-500 bg-clip-text text-transparent">강한 일본어</span> : Personal
          </h2>
          <p className="text-[15px] sm:text-[17px] text-gray-400">체계적인 일본어 학습 프로그램</p>
        </div>

        {/* 강한 일본어 플랜들 */}
        <div className="grid grid-cols-3 gap-2 sm:gap-6 md:gap-8 mb-24 sm:mb-40 max-w-[1200px] mx-auto">
          {/* 베이직 플랜 */}
          <div className={`bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] border border-gray-800 rounded-xl sm:rounded-2xl md:rounded-3xl p-2 sm:p-5 md:p-7 lg:p-9 hover:border-[#14B8A6]/50 hover:shadow-xl hover:shadow-[#14B8A6]/5 transition-all duration-500 transform hover:-translate-y-1 flex flex-col ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} style={{ transitionDelay: '200ms' }}>
            <div className="inline-block px-2 sm:px-4 md:px-5 py-1 sm:py-1.5 md:py-2 bg-[#14B8A6]/10 border border-[#14B8A6]/30 rounded-full mb-2 sm:mb-6 md:mb-8 w-fit">
              <span className="text-[9px] sm:text-[12px] md:text-[14px] font-semibold text-[#14B8A6]">입문</span>
            </div>
            <h3 className="text-[12px] sm:text-[24px] md:text-[32px] lg:text-[40px] font-bold text-white mb-1 sm:mb-3 md:mb-4 tracking-tight">LEXO Basic</h3>
            <p className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-500 mb-2 sm:mb-8 md:mb-10">일본어 입문자용</p>
            
            <div className="mb-2 sm:mb-8 md:mb-10">
              <p className="text-[14px] sm:text-[28px] md:text-[40px] lg:text-[48px] font-bold text-white mb-0.5 sm:mb-2 tracking-tight">₩78,000</p>
              <p className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-500">월 구독료</p>
            </div>
            <ul className="space-y-1 sm:space-y-3 md:space-y-4 lg:space-y-5 mb-2 sm:mb-8 md:mb-10 hidden sm:block">
              <li className="flex items-start gap-1 sm:gap-2 md:gap-3">
                <div className="w-3 h-3 sm:w-5 sm:h-5 md:w-6 md:h-6 bg-[#14B8A6]/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-[8px] sm:text-[12px] md:text-[14px] text-[#14B8A6]"></i>
                </div>
                <span className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-300 leading-relaxed">유튜브 링크 제공</span>
              </li>
              <li className="flex items-start gap-1 sm:gap-2 md:gap-3">
                <div className="w-3 h-3 sm:w-5 sm:h-5 md:w-6 md:h-6 bg-[#14B8A6]/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-[8px] sm:text-[12px] md:text-[14px] text-[#14B8A6]"></i>
                </div>
                <span className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-300 leading-relaxed">영상 속 핵심 표현 제공</span>
              </li>
              <li className="flex items-start gap-1 sm:gap-2 md:gap-3">
                <div className="w-3 h-3 sm:w-5 sm:h-5 md:w-6 md:h-6 bg-[#14B8A6]/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-[8px] sm:text-[12px] md:text-[14px] text-[#14B8A6]"></i>
                </div>
                <span className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-300 leading-relaxed">쉐도잉 숙제 제공</span>
              </li>
            </ul>
            <div className="mt-auto">
              <Link to="/personal" className="block w-full px-2 sm:px-6 md:px-8 py-1.5 sm:py-3 md:py-3.5 lg:py-4 bg-[#14B8A6] text-white text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] font-semibold rounded-lg sm:rounded-xl hover:bg-[#0D9488] hover:shadow-lg hover:shadow-[#14B8A6]/30 transition-all duration-300 whitespace-nowrap transform hover:scale-105 text-center cursor-pointer">
                자세히 보기
              </Link>
            </div>
          </div>

          {/* 스마트 플랜 */}
          <div className={`bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] border border-gray-800 rounded-xl sm:rounded-2xl md:rounded-3xl p-2 sm:p-5 md:p-7 lg:p-9 hover:border-[#14B8A6]/50 hover:shadow-xl hover:shadow-[#14B8A6]/5 transition-all duration-500 transform hover:-translate-y-1 flex flex-col ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} style={{ transitionDelay: '300ms' }}>
            <div className="inline-block px-2 sm:px-4 md:px-5 py-1 sm:py-1.5 md:py-2 bg-[#14B8A6]/10 border border-[#14B8A6]/30 rounded-full mb-2 sm:mb-6 md:mb-8 w-fit">
              <span className="text-[9px] sm:text-[12px] md:text-[14px] font-semibold text-[#14B8A6]">중급</span>
            </div>
            <h3 className="text-[12px] sm:text-[24px] md:text-[32px] lg:text-[40px] font-bold text-white mb-1 sm:mb-3 md:mb-4 tracking-tight">LEXO Smart</h3>
            <p className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-500 mb-2 sm:mb-8 md:mb-10">AI 작문 첨삭 포함</p>
            
            <div className="mb-2 sm:mb-8 md:mb-10">
              <p className="text-[14px] sm:text-[28px] md:text-[40px] lg:text-[48px] font-bold text-white mb-0.5 sm:mb-2 tracking-tight">₩98,000</p>
              <p className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-500">월 구독료</p>
            </div>
            <ul className="space-y-1 sm:space-y-3 md:space-y-4 lg:space-y-5 mb-2 sm:mb-8 md:mb-10 hidden sm:block">
              <li className="flex items-start gap-1 sm:gap-2 md:gap-3">
                <div className="w-3 h-3 sm:w-5 sm:h-5 md:w-6 md:h-6 bg-[#14B8A6]/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-[8px] sm:text-[12px] md:text-[14px] text-[#14B8A6]"></i>
                </div>
                <span className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-300 leading-relaxed">베이직 플랜 모든 혜택</span>
              </li>
              <li className="flex items-start gap-1 sm:gap-2 md:gap-3">
                <div className="w-3 h-3 sm:w-5 sm:h-5 md:w-6 md:h-6 bg-[#14B8A6]/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-[8px] sm:text-[12px] md:text-[14px] text-[#14B8A6]"></i>
                </div>
                <span className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-300 leading-relaxed">AI 작문 첨삭 제공</span>
              </li>
            </ul>
            <div className="mt-auto">
              <Link to="/personal" className="block w-full px-2 sm:px-6 md:px-8 py-1.5 sm:py-3 md:py-3.5 lg:py-4 bg-[#14B8A6] text-white text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] font-semibold rounded-lg sm:rounded-xl hover:bg-[#0D9488] hover:shadow-lg hover:shadow-[#14B8A6]/30 transition-all duration-300 whitespace-nowrap transform hover:scale-105 text-center cursor-pointer">
                자세히 보기
              </Link>
            </div>
          </div>

          {/* 프로 플랜 */}
          <div className={`bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] border-2 border-[#14B8A6] rounded-xl sm:rounded-2xl md:rounded-3xl p-2 sm:p-5 md:p-7 lg:p-9 relative shadow-2xl shadow-[#14B8A6]/20 hover:shadow-[#14B8A6]/30 transition-all duration-500 hover:-translate-y-1 flex flex-col ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} style={{ transitionDelay: '400ms' }}>
            <div className="absolute -top-2 sm:-top-4 md:-top-5 left-1/2 transform -translate-x-1/2">
              <span className="px-2 sm:px-5 md:px-7 py-1 sm:py-2 md:py-2.5 bg-gradient-to-r from-[#14B8A6] to-[#0D9488] text-white text-[8px] sm:text-[11px] md:text-[13px] font-bold rounded-full shadow-lg">
                인기
              </span>
            </div>
            <div className="inline-block px-2 sm:px-4 md:px-5 py-1 sm:py-1.5 md:py-2 bg-[#14B8A6]/10 border border-[#14B8A6]/30 rounded-full mb-2 sm:mb-6 md:mb-8 w-fit mt-2 sm:mt-0">
              <span className="text-[9px] sm:text-[12px] md:text-[14px] font-semibold text-[#14B8A6]">고급</span>
            </div>
            <h3 className="text-[12px] sm:text-[24px] md:text-[32px] lg:text-[40px] font-bold text-white mb-1 sm:mb-3 md:mb-4 tracking-tight">LEXO Pro</h3>
            <p className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-500 mb-2 sm:mb-8 md:mb-10">AI 첨삭 + PDF 자료</p>
            
            <div className="mb-2 sm:mb-8 md:mb-10">
              <p className="text-[14px] sm:text-[28px] md:text-[40px] lg:text-[48px] font-bold text-white mb-0.5 sm:mb-2 tracking-tight">₩128,000</p>
              <p className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-500">월 구독료</p>
            </div>
            <ul className="space-y-1 sm:space-y-3 md:space-y-4 lg:space-y-5 mb-2 sm:mb-8 md:mb-10 hidden sm:block">
              <li className="flex items-start gap-1 sm:gap-2 md:gap-3">
                <div className="w-3 h-3 sm:w-5 sm:h-5 md:w-6 md:h-6 bg-[#14B8A6]/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-[8px] sm:text-[12px] md:text-[14px] text-[#14B8A6]"></i>
                </div>
                <span className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-300 leading-relaxed">스마트 플랜 모든 혜택</span>
              </li>
              <li className="flex items-start gap-1 sm:gap-2 md:gap-3">
                <div className="w-3 h-3 sm:w-5 sm:h-5 md:w-6 md:h-6 bg-[#14B8A6]/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-[8px] sm:text-[12px] md:text-[14px] text-[#14B8A6]"></i>
                </div>
                <span className="text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] text-gray-300 leading-relaxed">PDF 자료 제공</span>
              </li>
            </ul>
            <div className="mt-auto">
              <Link to="/personal" className="block w-full px-2 sm:px-6 md:px-8 py-1.5 sm:py-3 md:py-3.5 lg:py-4 bg-gradient-to-r from-[#14B8A6] to-[#0D9488] text-white text-[8px] sm:text-[12px] md:text-[14px] lg:text-[15px] font-semibold rounded-lg sm:rounded-xl hover:shadow-xl hover:shadow-[#14B8A6]/40 transition-all duration-300 whitespace-nowrap transform hover:scale-105 text-center cursor-pointer">
                자세히 보기
              </Link>
            </div>
          </div>
        </div>

        {/* LEXO Biz & Black 섹션 헤더 */}
        <div className={`text-center mb-16 sm:mb-24 pt-8 sm:pt-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '800ms' }}>
          <h2 className="text-[40px] sm:text-[52px] lg:text-[60px] font-bold text-white mb-3 sm:mb-5 tracking-tight px-4">
            LEXO <span className="bg-gradient-to-r from-red-500 via-red-400 to-orange-500 bg-clip-text text-transparent">강한 일본어</span> : Special
          </h2>
          <p className="text-[15px] sm:text-[17px] text-gray-400">목적별 맞춤 일본어 학습</p>
        </div>

        {/* Biz 플랜 */}
        <div className="flex justify-center max-w-[1200px] mx-auto">
          {/* LEXO Biz */}
          <div id="biz" className={`w-full max-w-[280px] sm:max-w-[550px] relative group bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] border-2 sm:border-[3px] border-red-500 rounded-xl sm:rounded-3xl p-2 sm:p-11 hover:shadow-2xl hover:shadow-red-500/30 transition-all duration-500 transform hover:-translate-y-2 overflow-hidden flex flex-col ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} style={{ transitionDelay: '1000ms' }}>
            {/* 추천 배지 - 빨간색 */}
            <div className="absolute -top-2 sm:-top-5 left-1/2 -translate-x-1/2 z-20">
              <span className="px-2 sm:px-7 py-1 sm:py-2.5 bg-gradient-to-r from-red-500 to-red-600 text-white text-[8px] sm:text-[13px] font-bold rounded-full shadow-lg shadow-red-500/50">
                추천
              </span>
            </div>
            <div className="absolute inset-0 bg-gradient-to-br from-red-500/8 via-transparent to-transparent"></div>
            <div className="relative z-10 flex flex-col flex-1 text-center">
              <div className="inline-block px-2 sm:px-5 py-1 sm:py-2 bg-red-500/20 border sm:border-2 border-red-500 rounded-full mb-2 sm:mb-8 w-fit mt-2 sm:mt-0 mx-auto">
                <span className="text-[9px] sm:text-[14px] font-semibold text-red-500">사업자용</span>
              </div>
              <h3 className="text-[12px] sm:text-[40px] font-bold text-white mb-1 sm:mb-4 tracking-tight">LEXO Biz</h3>
              <p className="text-[8px] sm:text-[15px] text-gray-500 mb-2 sm:mb-10">일본 사업 진출자용</p>

              <ul className="space-y-1 sm:space-y-5 mb-2 sm:mb-10 hidden sm:block text-center mx-auto">
                <li className="flex items-center justify-center gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[13px] sm:text-[14px] text-white"></i>
                  </div>
                  <span className="text-[14px] sm:text-[15px] text-gray-300 leading-relaxed">사업자 실무 표현 PDF 제공</span>
                </li>
                <li className="flex items-center justify-center gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[13px] sm:text-[14px] text-white"></i>
                  </div>
                  <span className="text-[14px] sm:text-[15px] text-gray-300 leading-relaxed">원어민 음성 파일</span>
                </li>
                <li className="flex items-center justify-center gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[13px] sm:text-[14px] text-white"></i>
                  </div>
                  <span className="text-[14px] sm:text-[15px] text-gray-300 leading-relaxed">원어민 녹음 첨삭</span>
                </li>
              </ul>

              <div className="mt-auto">
                <Link to="/biz" className="block w-full px-2 sm:px-8 py-1.5 sm:py-4 bg-gradient-to-r from-red-500 to-red-600 text-white text-[8px] sm:text-[15px] font-semibold rounded-lg sm:rounded-xl hover:shadow-xl hover:shadow-red-500/40 transition-all duration-300 whitespace-nowrap transform hover:scale-105 cursor-pointer text-center">
                  자세히 보기
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
